import { useMediaQuery } from '@mui/material';
import {
  IDeaRegistration,
  roleLabel,
  roles,
  useDeaRegistrations,
  useDocumentTitle,
} from '../common';
import { registrationProperties, Registrations2d, RegistrationsStack } from '.';
import {
  map as lmap,
  orderBy as lorderBy,
  compose as lcompose,
} from 'lodash/fp';

export function Registrations() {
  useDocumentTitle({ title: 'CSOS Certificates' });

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  const { deaRegistrations, getRegistrationsCallStatus } =
    useDeaRegistrations();

  const items = lcompose(
    lorderBy(['deaNum'], ['asc']),
    lmap<IDeaRegistration, IDeaRegistration>(a => ({
      ...a,
      role: roleLabel(roles)(a.role),
    }))
  )(deaRegistrations) as IDeaRegistration[];

  return matchesGridBreakpoint ? (
    <Registrations2d
      properties={registrationProperties}
      deaRegistrations={items}
      getRegistrationsCallStatus={getRegistrationsCallStatus}
    />
  ) : (
    <RegistrationsStack
      properties={registrationProperties}
      deaRegistrations={items}
      getRegistrationsCallStatus={getRegistrationsCallStatus}
    />
  );
}
